import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminPromptInstructionsRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/settings/prompt-instructions',
}).lazy(() => import('pages/admin/Settings/PromptInstructionsPage').then((d) => d.Route));
